import React, { useEffect, useRef, useState } from 'react'
import MarketDetailsFilters from './MarketDetailsFilters';
import { getEntityPriority } from '../../../services/services';
import { useSelector } from 'react-redux';
import { setMarketLevelTabsList } from '../../../../../stateManagement/actions/manageCouponActions';
import CouponLoader from '../../CouponLoader';
import { ConfirmationPopUp } from '../../../../../components/popup/confirmationPopUp';
import { labelMappings } from '../../../utils/utils';
import { deepClone } from '@mui/x-data-grid/utils/utils';
import { getMarketTabsList } from './service';
import { MarketFiltersTypes } from '../../../types';

let INITIAL_STATE: Record<string, any> = {}

/**
 * Market filter component
 * This component is responible for handling and data selection in market/location selector
 * @param props 
 * @returns 
 */
function MarketFilters(props:MarketFiltersTypes) {

    const {handleChange,editMode , values , getMarketOptions,loading,multiple,arbitraryList} = props;

    const [currentTab, setCurrentTab] = useState<number>(0);
    const {marketLevelTabsList,outletLevelTabsList} = useSelector((state:any)=>state?.manageCoupons?.configData);
    const [tabsLoading , setTabsLoading] = useState<boolean>(false);

    const [confirmationDetails , setConfirmationDetails] = useState<{message:string,open:boolean}>({message:'',open:false});
    const successMethodRef = useRef(()=>{});

    const handleTabChange = (event: React.SyntheticEvent, newValue: number): void => {
        setCurrentTab(newValue);
    }

    const onSelect = (currentSelectedValues:string[],currentTabName:string)=>{
        const currentEntityPriority = getEntityPriority(currentTabName);
        let filteredLocationData: Record<string, any> = deepClone({ ...values.schemeLocationBifurcations });
        let isLowerPriorityRemoved = false;

        // checking if something is selected in market details lower priority tabs
        marketLevelTabsList.forEach((tab:string) => {
            // higher value means lower priority
            if (getEntityPriority(tab) > currentEntityPriority && filteredLocationData[tab]?.length>0) {
                filteredLocationData[tab] = [];
                isLowerPriorityRemoved = true;
            } else {
                filteredLocationData[tab] = values.schemeLocationBifurcations[tab];
            }
        })

        const newLocationVal = {
            ...filteredLocationData,[currentTabName]:currentSelectedValues
        }

        let filteredOutletData: Record<string, any> = deepClone({ ...values.schemeOutletBifurcations });
        let isLowerPriorityRemovedInOutlet = false;
        // checking if something is selected in market details lower priority tabs
        outletLevelTabsList.forEach((tab:string) => {
            // higher value means lower priority
            if (getEntityPriority(tab) > currentEntityPriority && filteredOutletData[tab]?.length>0) {
                filteredOutletData[tab] = [];
                isLowerPriorityRemovedInOutlet = true;
            } else {
                filteredOutletData[tab] = values.schemeOutletBifurcations[tab];
            }
        })
        
        let msg:string = "";

        if(isLowerPriorityRemoved && isLowerPriorityRemovedInOutlet){
            msg = labelMappings["TABS_RESET_OUTLET_AND_MARKET"]
            successMethodRef.current = ()=>{
                handleChange('schemeLocationBifurcations',newLocationVal);
                handleChange('schemeOutletBifurcations',filteredOutletData);
            }
            
        }
        else if(isLowerPriorityRemoved){
            // showing appropriate conformation message
            msg = labelMappings["TABS_LOWER_PRIORITY_DATA_RESET"]
            successMethodRef.current = ()=>{
                handleChange('schemeLocationBifurcations',newLocationVal);
            }
                      
        }
        else if(isLowerPriorityRemovedInOutlet){
            msg = labelMappings["TABS_RESET_OUTLET"]
            successMethodRef.current = ()=>{
                handleChange('schemeOutletBifurcations',filteredOutletData);
                handleChange('schemeLocationBifurcations',newLocationVal);
            }
        }
        else{
            handleChange('schemeLocationBifurcations',newLocationVal);
        }

        if(msg !== ""){
            setConfirmationDetails(()=>({message:msg,open:true}))  
        }
    }


	const getTabsList = async()=>{
        setTabsLoading(true);
		try {
			const res = await getMarketTabsList();
            res.forEach((item: string) => {
                INITIAL_STATE[item] = []
            })
            handleChange && handleChange('schemeLocationBifurcations',INITIAL_STATE);
			setMarketLevelTabsList(res);
		} catch (error) {
			console.error(error);
		}finally{
            setTabsLoading(false);
        }
	}
    
   useEffect(()=>{
        if(!editMode)
            getTabsList();
	},[])

    return (
        <div className='market-filters-wrapper'>
            {
                tabsLoading ? <CouponLoader /> :
                            <MarketDetailsFilters
                                arbitraryList={arbitraryList}
                                getTabContent={getMarketOptions}
                                tabsList={marketLevelTabsList}
                                handleTabChange={handleTabChange}
                                currentTab={currentTab}
                                onSelect={onSelect}
                                data={values.schemeLocationBifurcations}
                                combinedSelectedValues={values}
                                loading={loading}
                                filterName={"market"}
                                multiple={multiple}
                            />
                     
            }
            <ConfirmationPopUp
                message={confirmationDetails.message}
                openConfirmModal={confirmationDetails.open}
                setOpenConfirmModal={(val)=>setConfirmationDetails(()=>({message:"",open:val as boolean}))}
                successMethod={successMethodRef.current}
            />
        </div>
    )
}

export default React.memo(MarketFilters)